import { HttpContextToken, HttpContext } from '@angular/common/http';

export interface ITermsContext {
  userAuthorized: boolean;
  clientId: string | null;
}

export const IS_USER_AUTHORIZED = new HttpContextToken<ITermsContext>(() => ({
  userAuthorized: false,
  clientId: null,
}));

export function termsCall(clientId: string) {
  return new HttpContext().set(IS_USER_AUTHORIZED, { userAuthorized: true, clientId });
}
